import styled from "styled-components";

export const LanguageSelectContainer = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const LanguageButton = styled.button`
background: transparent;
border: 1px solid ${props => props.$colors.border};
color: ${props => props.$colors.textSecondary};
padding: 8px 12px;
border-radius: 6px;
cursor: pointer;
display: flex;
align-items: center;
justify-content: space-between;
gap: 8px;
transition: all 0.15s;
font-size: 12px;
width: 100%;
max-width: 200px;

&:hover {
  background: ${props => props.$colors.bgTertiary};
  color: ${props => props.$colors.text};
}

svg {
  width: 12px;
  height: 12px;
  opacity: 0.6;
}
`;

export const LanguageDropdown = styled.div`
position: absolute;
bottom: calc(100% + 4px);
right: 0;
background: ${props => props.$colors.bgSecondary};
border: 1px solid ${props => props.$colors.border};
border-radius: 6px;
margin-top: 4px;
overflow: hidden;
box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
z-index: 100;
min-width: 140px;
width: 100%;
`;

export const LanguageOption = styled.button`
  width: 100%;
  background: ${props => props.$active ? props.$colors.bgTertiary : 'transparent'};
  border: none;
  color: ${props => props.$colors.text};
  padding: 10px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  transition: all 0.15s;
  
  &:hover {
    background: ${props => props.$colors.bgTertiary};
  }
  
  .flag {
    font-size: 14px;
  }
`;

